export const EDITOR_ONLY = "EDITOR_ONLY";
export const RECORDER_ONLY = "RECORDER_ONLY";
export const EDITOR_AND_RECORDER = "EDITOR_AND_RECORDER";
